<template>
 <form>
    <div class="error-msg small-top" v-if="error">
      A clients home page must be a feature that is toggled on.
    </div>
    <h-select v-model='profile.home' :no-none='true' itemText="display" itemValue='value' label="Home Page" :items='homeOptions' />
    <h3 class="small-top">Allowed Features</h3>
    <h-input v-model='profile.allow_daily_exercises' type="checkbox" label="Daily Habits" />
    <h-input v-model='profile.allow_self_reflect' type="checkbox" label="Daily Reflections" />
    <h-input v-model='profile.allow_goals' type="checkbox" label="Goals" />
    <h-input v-model='profile.allow_progress' type="checkbox" label="Progress" />
    <h-input v-model='profile.allow_courses' type="checkbox" label="Courses" />
    <h-input v-model='profile.allow_journal' type="checkbox" label="Journal" />
    <h-input v-model='profile.allow_assessments' type="checkbox" label="Assessments" />
    <h-input v-model='profile.allow_messaging' type="checkbox" label="Messaging" />
  </form> 
</template>


<script>
export default {
  props: ["profile"],
  data() {
    return {
      homeOptions: [
        { display: "Daily Habits", value: "daily_exercises" },
        { display: "Self Reflect", value: "self_reflect" },
        { display: "Goals", value: "goals" },
        { display: "Progress", value: "progress" },
        { display: "Courses", value: "courses" },
        { display: "Assessments", value: "assessments" }
      ]
    };
  },
  computed: {
    error() {
      if (!this.profile['allow_' + this.profile.home]) {
        this.$emit('error', true)
        return true;
      } else {
        this.$emit('error', false)
        return false;
      }
    }
  }
}
</script>
